import { type Courses } from "@common/components/Courses/types";
import Accordion, { AutoExpandItems } from "@common/controls/Accordion";
import Search from "@common/controls/Inputs/Search/component";
import Select from "@common/controls/Inputs/Select/component";
import { type OptionItem } from "@common/declarations";
import { useI18n } from "@common/hooks/i18n";
import React from "react";

type Props = {
  lessonId: string;
  allFaq: Courses.LessonFaq[];
};
export default (props: Props) => {
  const i18n = useI18n();

  const [searchText, setSearchText] = React.useState("");
  const lessonFaq = React.useMemo(() => props.allFaq.filter((x) => x.lessonId === props.lessonId), [props.allFaq]);
  const [optionValue, setOptionValue] = React.useState(lessonFaq.length ? "this" : "all");

  React.useEffect(() => setOptionValue(lessonFaq.length ? "this" : "all"), [lessonFaq, setOptionValue]);

  const options = React.useMemo((): OptionItem<string>[] => {
    const options: OptionItem<string>[] = [{ label: i18n.allLessons, value: "all" }];
    if (lessonFaq.length) {
      options.push({ label: i18n.thisLesson, value: "this" });
    }
    return options;
  }, [i18n, lessonFaq]);

  const items = React.useMemo(
    () => (optionValue === "this" ? lessonFaq : props.allFaq),
    [lessonFaq, optionValue, props.allFaq]
  );

  const filteredItems = React.useMemo(() => {
    if (!searchText) return items;

    return items.filter(
      (x) =>
        x.question.toLowerCase().includes(searchText.toLowerCase()) ||
        x.answer.toLowerCase().includes(searchText.toLowerCase())
    );
  }, [items, searchText]);

  return (
    <div className="faq">
      <div className="heading">
        <Search
          onChange={setSearchText}
          onChangeTrigger={300}
          placeholder={optionValue === "this" ? i18n.searchThisLessonFaq : i18n.searchAllLessonsFaq}
          value={searchText}
        />
        <Select isRequired onChange={setOptionValue} options={options} value={optionValue} />
      </div>

      <Accordion autoExpand={AutoExpandItems.None}>
        {filteredItems.map((x) => (
          <Accordion.Item key={x.answerId} label={x.question}>
            <div className="item" dangerouslySetInnerHTML={{ __html: x.answer }} />
          </Accordion.Item>
        ))}
      </Accordion>
    </div>
  );
};
